import React, { useCallback } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem, PopoverOrigin } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { useFeatureFlag, useMenuState } from 'modules/common/hooks';
import { useMessages } from 'modules/intl';
const useStyles = makeStyles((theme) => ({
  btn: {
    padding: theme.spacing(0.75)
  },

  overflow: {
    color: theme.palette.text.primary
  }
}));

const messageKeys = ['timesheetLabels.denyAllSuggestions'];
const anchorOrigin: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right'
};
const transformOrigin: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right'
};
type BulkSuggestionMoreActionsProps = {
  denyAllSuggestionHandler: () => void;
  enableActions: boolean;
  fieldName: string;
};
export const BulkSuggestionMoreActions: React.FC<BulkSuggestionMoreActionsProps> = ({
  denyAllSuggestionHandler,
  enableActions,
  fieldName
}: BulkSuggestionMoreActionsProps) => {
  const messages = useMessages(messageKeys);
  const classes = useStyles();
  const { anchorEl, onMenuClose, onMenuClick } = useMenuState();
  const denyAllHandler = useCallback(() => {
    denyAllSuggestionHandler();
    onMenuClose();
  }, [denyAllSuggestionHandler, onMenuClose]);

  const isTiwScreenReaderEnabled = useFeatureFlag('isTiwScreenReaderEnabled');

  const { formatMessage } = useIntl();
  const denySuggesstionMsg = formatMessage(
    {
      id: 'note.addNoteDialog.denySuggestions'
    },
    { value: fieldName }
  );

  return (
    <div>
      <IconButton
        data-testid={`labels-overflow-action-btn-${fieldName}`}
        className={classnames(classes.btn, classes.overflow)}
        onClick={onMenuClick}
        size="large"
        aria-label={isTiwScreenReaderEnabled ? denySuggesstionMsg : undefined}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onMenuClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        <MenuItem
          data-testid={`deny-all-suggestions-${fieldName}`}
          disabled={!enableActions}
          onClick={denyAllHandler}
        >
          {messages['timesheetLabels.denyAllSuggestions']}
        </MenuItem>
      </Menu>
    </div>
  );
};
